import {Injectable} from '@angular/core';
import { Route, Router, UrlSegment } from '@angular/router';
import {Observable} from 'rxjs';
import {KeycloakService} from 'keycloak-angular';
import {Role} from '../../clm/types/role.enum';
import {EnvironmentService} from '../services/environment-service';

@Injectable({
  providedIn: 'root'
})
export class ProviderPortalGuard  {
  userRoles: string[];
  private readonly hasProviderPortalAccess: boolean;
  private readonly rolesRequiredForProviderPortal: string[] = [Role.Provider];

  constructor(
    private router: Router,
    private keycloakService: KeycloakService,
    private environmentService: EnvironmentService) {

    this.hasProviderPortalAccess = this.environmentService.isAllowedToAccessProviderPortal();
    this.userRoles = this.keycloakService.getUserRoles();
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    const hasExpectedRole: boolean = this.rolesRequiredForProviderPortal.some((role: string) => this.userRoles.includes(role));

    if (!this.userRoles.length || !hasExpectedRole) {
      this.router.navigateByUrl('/');
      return false;
    }
    else if (!this.hasProviderPortalAccess) {
      this.router.navigateByUrl('/');
      return false;
    }

    return true;
  }

}
